import { CommonViewController } from '../../controller/CommonViewController';
import { CSVService } from '../../services/export/csv/CSVService';
import { FilterUtil } from '../utils/filtering/FilterUtil';
import { ReportService } from '../../services/export/ReportService';
import { ExportModalBean } from "../export/ExportModalBean";
import { EXPORT_TYPE } from "../export/ExportModalController";
import { downloadSettingsValueKey } from "fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-download-settings";
import { TAB_ACCOUNT } from "../../views/accounts/overview";
import { USERREPORT_ACCOUNTROUTE } from "../../views/accounts/AccountController";
import {
    statementOptions,
    valueSeriesOptions
} from '../../views/administration/userReports/UserReportDetailDialogController';
import { EXPORT_MODAL } from "../../routes/export.route";

/** @ngInject */
export class TableGroupController extends CommonViewController {

    constructor($scope, userService, arsMainDependencies, groupService, paramsKey, colDefs, url, filePrefix, tableKey) {

        super($scope, userService, arsMainDependencies);

        this.$rootScope = userService.fsMainDependencies.$rootScope;
        this.backendService = groupService;
        this.tableParamsKey = paramsKey;
        this.$filter = userService.filterFormatter;
        this.supportedExports = [EXPORT_TYPE.CSV, EXPORT_TYPE.XLSX];
        this.colDefs = colDefs;
        this.tableKey = tableKey;
        this.url = url;

        userService.promise.then(()=> {
            const currLng = this.ftsMainDependencies.$rootScope.portalUser?.impersonatedUser
                ? this.ftsMainDependencies.$rootScope.portalUser?.impersonatedUser.settings.language
                : this.ftsMainDependencies.settings.language;
            this.ftsMainDependencies.$translate.use(currLng).then(()=> {

                this.cols = this.applyColumnDefs(tableKey, colDefs);
                this.csvService = new CSVService(arsMainDependencies.ArsConfig, userService);
                this.reportService = new ReportService(this, arsMainDependencies.ArsConfig, userService);
            });
        });

        this.tableIdPrefix = 'accountGroup';
        this.filePrefix = filePrefix;

        $scope.$on('reportType', (event, params) => {
            this.generateReport(params);
        });

        $scope.$on('exportGroup', (event, params) => {

            if (this.checkPDFExport(params)) {

                this.generateReport(params);
            }
            else if (this.filterEvent(params)) {
                this.exportCSV(params.group, params.tableId, params.reportType);
            }
        });
    }

    checkPDFExport(params){
        if (params == null || params.reportType == null || params.reportType.value == null) return false;
        return params.reportType.value.startsWith('PDF') ? params : null; // Send params for PDF export
    }

    generateReport(params) {
        if (this.filterEvent(params)) {
            this.originalFilter = this.backendService.service.config.params.filter;
            this.dataFilter([this.$scope.itemSel, params.group]);
            this.reportService.exportFile(params, params.reportType.method);
        }
    }

    // Overridden for sub-group
    filterEvent(params) {
        return this.$scope.tableId === params.parentTableId && params.group.$hideTable; // Group with no sub-group
    }

    format() {
        this.groups.forEach(group => {
            group.$hideTable = true;
            group.$hideGroupTable = true;
        });
    }

    // Prepare filter for ng-table with selected items from ui-select
    dataFilter(data) {
        this.backendService.service.config.params.filter = FilterUtil.constructFilter(data, this.$scope);
        this.backendService.service.config.params.filter.dateTo = this.$rootScope.pickedDate;
    }

    getTableID(index) {
        return this.tableIdPrefix + (this.tabName ? this.tabName : "") + index; // table identifier used to filter the event;
    }

    // ARSWEB-440: List of other countries disappear
    callWithFilter(group, generateReport) {
        this.originalFilter = this.backendService.service.config.params.filter;
        const copyGroup = Object.assign({}, group);
		// BY accounts group filter field loadKey
        copyGroup.kind = (group.kind === TAB_ACCOUNT) ? 'loadKey' : group.kind;
        this.dataFilter([this.$scope.itemSel, copyGroup]);
        generateReport();
    }

    resetFilter() {
        this.backendService.service.config.params.filter = this.originalFilter;
    }

    exportCSV(group, tableId, reportType) {
        this.masterRowCount = this.getMasterRowCount(group);
        if (group.$hideTable) {
            this.cols = this.applyColumnDefs(this.tableKey, this.colDefs);
            this.callWithFilter(group,
                () => this.csvService.export(
                    this, this.url, this.cols, this.modal, this.filePrefix, reportType, reportType.value));
        } else {
            // For sub groups, we need to send the parent table id too
            const param = { parentTableId: this.$scope.tableId, tableId: tableId, reportType: {method: reportType.method}};
            this.$rootScope.$broadcast('export', param);
        }
    }

    checkForElements(group, index) {
        // grouping is expanded
        if(!group.$hideTable) {
            this.$rootScope.$broadcast('checkElements');
            if(this.$rootScope[this.getTableID(index)]) {
                if(this.$rootScope[this.getTableID(index)].checkElements === 0 ){
                    this.infoPop('NO_ROW_SELECTED');
                    return false;
                } else if(this.$rootScope[this.getTableID(index)].overLimit) {
                    return false;
                }
            }
        }
        return this.$rootScope.overLimit ? false : true;
    }

    openPopupForReport(group, index, subGroup) {

        if( this.checkForElements(group, index)) {
            // accounts group view
            const USERREPORTSTATE = this.state.get(USERREPORT_ACCOUNTROUTE);
            this.state._params = USERREPORTSTATE.params;
            this.state._params.consolitationcurrency = this.$scope.consolitationcurrency;
            // choose document type
            this.state._params.fileType = this.$scope.accountsGroupTableController ? statementOptions : valueSeriesOptions;
            delete this.state._params.group;
            this.state._params.tableFilter =  this.$rootScope[this.getTableID(index)] ?
                this.$rootScope[this.getTableID(index)].tableFilter : [];
            this.state._params.tableCount =  this.$rootScope[this.getTableID(index)] ?
                this.$rootScope[this.getTableID(index)].tableCount : 25;
            if(subGroup) {
                this.state._params.selectAll = true;
                // choose accounts for group and subgrooup on userrepot
                this.state._params.tableFilter =
                    FilterUtil.constructFilter([this.$scope.itemSel, group], this.$scope);
                this.state._params.tableCount = group.numberOfAccounts;
                this.openReportModal(USERREPORTSTATE);
            } else {// choose group on user report

                this.state._params.selectAll = false;
                delete this.state._params.tableFilter;
                this.state._params.group = group;
                this.openReportModal(USERREPORTSTATE);
            }
        }
    }

    openReportModal(state) {
        const USER_REPORT_MODAL = {
            templateUrl: state.templateUrl,
            controller: state.controller,
            controllerAs: state.controllerAs,
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            multiple: true};
        this.modal.show(USER_REPORT_MODAL).catch(() => {});
    }

    openPopupForExport(group, index) {
        const exportModal = EXPORT_MODAL;
        exportModal.resolve ={
            exportModalBean: () => new ExportModalBean(this.supportedExports,
                { parentTableId: this.$scope.tableId, tableId: this.getTableID(index), group}, group)
        };

        this.modal.show(exportModal).catch(() => { });
    }

    checkExport(group, index) {
        if( this.checkForElements(group)) {
            const userSettings = this.sessionPersistance.get(downloadSettingsValueKey);
            const exportFormat = userSettings ? userSettings.exportFormat : 'SETTINGS_EXPORTFORMAT_OPTION_NONE';
            if(exportFormat === 'SETTINGS_EXPORTFORMAT_OPTION_NONE') {
                this.openPopupForExport(group, index);
            }  else {
                this.broadcastOption(
                    exportFormat === 'SETTINGS_EXPORTFORMAT_OPTION_CSV' ? EXPORT_TYPE.CSV : EXPORT_TYPE.XLSX,
                    group, index);
            }
        }
    }

    broadcastOption(selectedExport, group, index) {
        const params = { reportType: selectedExport, userFunction: selectedExport.userFunction,
            group: group, tableId: this.getTableID(index), parentTableId: this.$scope.tableId};
        if(this.$rootScope.checkElements || !params.group) {
            this.$rootScope.$broadcast('export', params);
        } else {
            if (this.filterEvent(params)) {
                this.exportCSV(params.group, params.tableId, params.reportType);
            }
        }
    }

    loadSelGroup(group, persisGr) {
        group.$hideTable = false;
        group.$hideGroupTable = persisGr.hideGroupTable;
        if (persisGr.subGrouping && persisGr.subGrouping !== '') {
            group.subGrouping = persisGr.subGrouping;
        }
    }

    updateGroup(group, index) {
        // hidding removes table from list
        if(!group.$hideTable) {
            // hides table remove from list and rootscope
            const tableId = this.getTableID(index);
            const gridApi = this.$rootScope[tableId];
            this.$rootScope.tables?.splice(this.$rootScope.tables.indexOf(gridApi), 1);
            delete this.$rootScope[tableId];
        }
        group.$hideTable = !group.$hideTable;
    }

    getDataKey() {
        return this.tableParamsKey + '.' + this.$scope.tableId;
    }

    getMasterRowCount(group) {
        return group.numberOfAccounts;
    }

    applyColumnDefs(tableKey, defaultCols) {
        if(this.sessionPersistance.get(tableKey) && this.sessionPersistance.get(tableKey).columns){
            const storedCols = this.sessionPersistance.get(tableKey).columns;
            const stateCols = defaultCols.filter(defCol => {
                const stateCol = storedCols.filter(col => defCol.field === col.columnName && col.visible);
                if(!_.isNil(stateCol) && stateCol.length > 0) {
                    defCol.columnIndex = stateCol[0].columnIndex;
                    return defCol;
                }
            });

            return !_.isNil(stateCols) && stateCols.length > 0 ?
                stateCols.sort((a, b) => Number(a.columnIndex) - Number(b.columnIndex)) :
                defaultCols;
        }
        return defaultCols;
    }
}
